import templateUrl from './template.html';

export const janglPageDoneComponent = {
    templateUrl: templateUrl,
    bindings: {
        // pass in the parent to get it's doneCopy'
        parent: '<',
    }
}


export default janglPageDoneComponent;


// WEBPACK FOOTER //
// ./app/jangl/jangl-page-done/component.js